@if (hasWatcher) {
    <span class="small ms-2">Watching this</span>
}
<adapt-menu [items]="menuItems"
            [showOnHover]="true"
            orientation="vertical"></adapt-menu>
